module.exports = __webpack_public_path__ + "img/img_xinshouzhuanqu.2de72233.png";